import React from 'react';
import { ORG_ADMIN_ROLE, ROLE_ORG_STAFF, userFormCompanyEntities } from '../../helpers/constants';
import EntityCRUD from '../EntityCrud/EntityCrud';
import SlidingSideBar from '../SlidingSideBar/SlidingSideBar';

const UsersFromCompany = ({ usersFromOrganization, onUsersFromOrganizationChange }) => {
  return (
    <SlidingSideBar
      title={usersFromOrganization?.name}
      visible={usersFromOrganization !== null}
      fullScreen
      onClose={() => onUsersFromOrganizationChange(null)}
    >
      {usersFromOrganization &&
        userFormCompanyEntities([ORG_ADMIN_ROLE, ROLE_ORG_STAFF], usersFromOrganization).map(e => {
          return (
            <EntityCRUD
              usersFromOrganization={usersFromOrganization}
              entityAppChoiceKey={e.appChoiceKey}
              entityName={e.name}
              endpoint={e.endpoint}
              entityTableHeaders={e.tableHeaders}
              entityTableSearchKeys={e.searchKeys}
              addFormRows={e.addRows}
              updateFormRows={e.updateRows}
              onUsersFromOrganizationChange={onUsersFromOrganizationChange}
              updateEndpoint={e.updateEndpoint}
              isEnabledFilter={true}
            />
          );
        })}
    </SlidingSideBar>
  );
};

export default UsersFromCompany;
